/*
|--------------------------------------------------------------------------
| Views: Featured With Grid
|--------------------------------------------------------------------------
*/

/**
 * Featured With Grid
 * @namespace
 */
__gh__webApp.views.featuredWithGrid = {
	
	"callbacks": function(bucket){
		__gh__webApp.views.featuredWithBucket.callbacks({
			"bucket"		: bucket,
			"bucket2View"	: "grid"
		});
	},
	
	
	"defaultAds":{
		"noFeaturedSingleBucket":{
			"slot6": {},
			"slot4": {
				"view": "buckets/partials/ads/_billboard"
			}
		}
	},
	
	
	"getSubView": function(bucket){
		var	views					= __gh__webApp.views;
		
		return views.featuredWithBucket.getSubView({
			"bucket": bucket,
			"bucket2View": "grid"
		});

	}
};